import { createContext, useState } from "react";

export const Context = createContext();

const AppContext = ({ children }) => {
  const [valueFrom, setValueFrom] = useState("");
  const [valueTo, setValueTo] = useState("");
  const [cities, setCities] = useState();
  const [russianCities, setRussianCities] = useState();

  const [codeFrom, setCodeFrom] = useState("");
  const [codeTo, setCodeTo] = useState("");
  const [modalTitle, setModalTitle] = useState();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [takeOfSender, setTakeOfSender] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [success, setSuccess] = useState();
  const [error, setError] = useState(false);

  let [inputFields, setInputFields] = useState([
    {
      id: Math.random().toString(36).substring(10),
      length: "",
      width: "",
      height: "",
      weight: "",
      seats: "",
    },
  ]);

  return (
    <Context.Provider
      value={{
        valueFrom,
        setValueFrom,
        valueTo,
        setValueTo,
        loading,
        setLoading,
        openModal,
        setOpenModal,
        totalCount,
        setTotalCount,
        cities,
        setCities,
        russianCities,
        setRussianCities,
        inputFields,
        setInputFields,
        takeOfSender,
        setTakeOfSender,
        delivery,
        setDelivery,
        insurance,
        setInsurance,
        success,
        setSuccess,
        error,
        setError,
        codeFrom,
        setCodeFrom,
        codeTo,
        setCodeTo,
        modalTitle,
        setModalTitle,
      }}
    >
      {children}
    </Context.Provider>
  );
};
export default AppContext;
